
import React, { useMemo, useState, useCallback, useEffect } from 'react'
import { AppBody, AppBodyBailleur, AppContainer, AppContent } from '../../../styles/App.styled';
import { Navigate, Route, useLocation, Routes, useNavigate } from 'react-router-dom';
import Menu from '../../Menu/Menu'
import SaveIcon from '@mui/icons-material/Save';
import Header from '../../../components/Header/Header'
import Campaigns from '../../Campaigns/Campaigns';
import CampaignForm from '../../CampaignForm/CampaignForm';
import UserForm from '../../UserForm/UserForm';
import Entity from '../../Entity/Entity';
import UserEntity from "../../UserForm/UserEntity"
import PdfViewerPage from "../../PdfViewerPage/PdfViewerPage"
import { connect } from 'react-redux';
import Axios from '../../../axios-proas';
function ClientRoot({ userRoles, userType, BailleurId, URL, utilisateurHasPermissionSaisieEnquete, utilisateurHasPermissionControleEnquete }) {

    const [bailleur, setBailleur] = useState();
    const navigate = useNavigate()
    const Referrer = localStorage.getItem("parentLocation")?.split('/')?.pop();
    console.log(URL)
    useEffect(() => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/' + BailleurId, {
            params: null,
        },).then((response) => {
          
            setBailleur(response.data)
          }).catch(err => {
            notyf.error("Une erreur s'est produite!");
          })

          let nav = Referrer ? "/" + Referrer : "/";
          if (["showGuideProduction", "showGuideTeledeclaration"].includes(Referrer))
              navigate(nav)
          else
              navigate('/entity/' + BailleurId)

    }, [BailleurId])

    const menuItems = useMemo(() => (
        [
            { isLink: true, key: 'TableauBord', label: "Tableau de bord ", pathname: `${URL}/Bailleur/TableauBord`, icon: <SaveIcon /> },

            { isLink: true, key: 'Consultation', label: "Consultation", pathname: `${URL}/Bailleur/Consultation`, icon: <SaveIcon /> },

            (bailleur?.controleInterne && utilisateurHasPermissionControleEnquete) ? { isLink: true, key: 'ControleEnquete', label: "Contrôle enquête", pathname: `${URL}/BackOffice/BrowseControleEnquete`, icon: <SaveIcon /> }:false,

            (bailleur?.saisieInterne && utilisateurHasPermissionSaisieEnquete) ? { isLink: true, key: 'SaisieExterne', label: "Saisie enquête", pathname: `${URL}/BackOffice/BrowseSaisieExterne`, icon: <SaveIcon /> }:false,

            { isLink: true, key: 'Administration', label: "Administration", pathname: '/entity/' + BailleurId, icon: <SaveIcon /> },
        ]
    ), [BailleurId, URL, bailleur, utilisateurHasPermissionSaisieEnquete, utilisateurHasPermissionControleEnquete])

    const submenu = useCallback(() => {
        let menuTemp = menuItems;
        let temp = menuTemp.filter(item => item !== false)

        let menu = temp.map(item => {
            if (item.subMenu !== undefined) {
              return { ...item, subMenu: item.subMenu.filter(item => item !== false) }
            } else {
              return item
            }
          })
          return menu
   
    }, [bailleur, menuItems]);

    return (
        <>
            <AppContainer>
                {/*<div style={{ display: "flex", justifyContent: "center", color: "white", backgroundColor: "#82d616", height: "25px", alignItems: "center" }}>ENVIRONNEMENT éé DE DEVELOPMENT</div>*/}
                <div style={{ display: "flex", justifyContent: "center", height: "100px", alignItems: "center" }}>
            
                    <Header isEnqueteSatisfaction={false} />
                  
                </div>
              
                <AppBodyBailleur>
                    <Menu items={submenu()} userType={userType} bailleurId={BailleurId} />
                    <AppContent >
                        <Routes>
                           
                            <Route path="/entity/:uid" element={<Entity  />} />                           
                            <Route path="/entity" element={<Entity />} />
                            <Route path="/userForm/:uid" element={<UserForm />} />
                            <Route path="/userForm" element={<UserForm />} />                         
                            <Route path="/suiviCampagnes" element={<Campaigns />} />
                            <Route path="/newCampaign" element={<CampaignForm />} />
                            <Route path="/newCampaign/:uid" element={<CampaignForm />} />
                            <Route path="/userEntity/:uid" element={<UserEntity />} />
                            <Route path="/userEntity" element={<UserEntity />} />
                            <Route path="/showGuideTeledeclaration" element={<PdfViewerPage />} />
                            <Route path="/showGuideProduction" element={<PdfViewerPage />} />                           
                            <Route path="/" element={<></>} />
                        </Routes>
                    </AppContent>

                </AppBodyBailleur>
                    <div style={{ display: "flex", justifyContent: "center", height: "60px", alignItems: "center", borderTop: "1px solid #e5e5e5" }}>

                        <div style={{ display: "flex", alignItems: "end", fontSize: "1rem" }}>
                            <p style={{ color: "#67748e" }}>
                                &nbsp; {("default:copyright", `  ©${new Date().getFullYear()} - Créé par  `)}
                            </p>
                            <p style={{ color: "#0077cc" }}>
                                &nbsp; Younov
                            </p>
                       
                        </div>

                    </div>
            </AppContainer>
        </>
    )
}

const mapStateToProps = state => {
    return {
        userType: state.auth.userType,
        logo: state.auth.logo,
        URL: state.auth.URL,
        utilisateurHasPermissionSaisieEnquete: state.auth.utilisateurHasPermissionSaisieEnquete,
        utilisateurHasPermissionControleEnquete: state.auth.utilisateurHasPermissionControleEnquete,
    }
}
const mapDispatchToProps = dispatch => {
    return {
       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientRoot);
